import {
  AR_REPORT_DOC_NUMBER_FILTER,
  AR_REPORT_DOC_STATUS_FILTER
} from "constants/ActionTypes";

const initialState = {
  docNumberFilter: "",
  docStatusSelected: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AR_REPORT_DOC_NUMBER_FILTER:
      return {
        ...state,
        docNumberFilter: action.payload,
      };
    case AR_REPORT_DOC_STATUS_FILTER:
      return {
        ...state,
        docStatusSelected: action.payload,
      };
    default:
      return state;
  }
};
